// extracted by mini-css-extract-plugin
export default {"grid":"Adornments_grid__r1HDb"};